import { render, staticRenderFns } from "./SettingsTag.vue?vue&type=template&id=e0b8002c&"
import script from "./SettingsTag.vue?vue&type=script&lang=js&"
export * from "./SettingsTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports